// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> price-brothers-preferred -> wynnewood-farms
// Generated: 2026-11-03T22:56:54.419Z
// Counts: 2 design, 92 content, 15 slot group, 5 collection binding, 6 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pool, Fitness Center, Car Care Center &amp; More</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Talk With Our Leasing Team</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Quick Answers for </h2><h2>Future Residents</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Wynnewood Farms </h2><h2>Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Wynnewood Farms Apartments in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Room to Live in South Overland Park</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Minutes From Prairiefire, Parkway Plaza and Town Center</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Shopping, Dining, Parks &amp; More Near Wynnewood Farms</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Bark Bar at Wynnewood Farms</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Visit Wynnewood Farms</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Our 1, 2 &amp; 3 Bedroom Apartments Online</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "accessibilityhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Our commitment to accessible living at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments in Overland Park</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Begin your application for <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Wynnewood Farms in Overland Park</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions About Wynnewood Farms</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>1, 2 &amp; 3 Bedroom Overland Park Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Photos of Our Apartments in Overland Park</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the Wynnewood Farms Photo Gallery</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover modern living at Eastpark with in-unit laundry. Enjoy ultimate convenience in Denton, TX, where comfort meets stylish amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Denton, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Discover the neighborhood surrounding <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments Near Prairiefire in Overland Park</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "onebedroomhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>1 Bedrooms</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Overland Park Pet Friendly Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.benefits_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Program Benefits</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.callout_body": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.callout_title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive Savings for Local Professionals at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.footnote": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Preferred Employer Partners</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>How <span data-type=\"field-token\" data-field=\"property_name\"></span> collects, uses, and protects your information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccesshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident portal login and account tools for <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>What residents are saying about living at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Tour Our Apartments in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore nearby communities from Price Brothers Management Co. — each with its own character, amenities, and floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sisterpropertieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Nearby Communities From Price Brothers Management Co.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sisterpropertieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Browse all pages on the <span data-type=\"field-token\" data-field=\"property_name\"></span> website</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "studioshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Studio Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "studioshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Studios</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank you for reaching out to <span data-type=\"field-token\" data-field=\"property_name\"></span>—we will be in touch soon</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "townhomes-floor-plans.empty_message": {
    "overrideType": "VALUE",
    "customValue": "<p>There are no townhomes listed right now. Explore all of our floor plans or contact us for upcoming availability.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tours of Wynnewood Farms</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.employers": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>AdventHealth</p></li><li><p>Blue Valley School District</p></li><li><p>Garmin</p></li><li><p>Honeywell</p></li><li><p>Oracle Health</p></li><li><p>Menorah Medical Hospital</p></li><li><p>Johnson County Community College</p></li><li><p>T-Mobile</p></li><li><p>St. Luke's Hospital</p></li><li><p>Overland Park First Responders</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "featuredfloorplan.view_all_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Apply Now"
      },
      "url": {
        "type": "VALUE",
        "customValue": ""
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "preferredemployercta.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Apply Now"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-bc7e-770a-82f9-2d7d32e9b488.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-3224-74bd-b3a7-aee724e13d58.webp"
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Deer Creek Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "12849 Metcalf Ave, Overland Park, KS 66213"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=12849+Metcalf+Ave%2C+Overland+Park%2C+KS+66213"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.deercreekaptskc.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-e7ce-73fe-a116-048270f86b48.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Covered patio with outdoor furniture and a stone fireplace."
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Sorrento at Deer Creek Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "7700 W. 126th Terrace, Overland Park, KS 66213"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=7700+W+126th+Terrace%2C+Overland+Park%2C+KS+66213"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.sorrentoapartmentskc.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-cf9b-72ca-908a-3f4d88d9276d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a resort-style swimming pool and clubhouse at sunset."
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Stonebriar Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "12490 Quivira Rd, Overland Park, KS 66213"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=12490+Quivira+Rd%2C+Overland+Park%2C+KS+66213"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.stonebriarkc.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-cb69-73ec-bd71-1b405486bc8c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool area with lounge chairs, a fountain, and apartment buildings in the background."
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Crowne Chase Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "11621 W. 118th Terrace, Overland Park, KS 66210"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=11621+W+118th+Terrace%2C+Overland+Park%2C+KS+66210"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.crownechase.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-eb09-769c-8cfa-de66343b6b36.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of multifamily apartment building with a picnic table and lush green lawn."
      }
    }
  },
  "sisterproperties.community5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Cloverset Active Adult Apartments"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "10601 Jefferson St., Kansas City, MO 64114"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=10601+Jefferson+St%2C+Kansas+City%2C+MO+64114"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.cloversetapts.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-fea8-7759-826e-0ab8fc978d13.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a multifamily property with a pool, tennis court, and buildings."
      }
    }
  },
  "sisterproperties.community6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Stonebriar Woods Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "12401 W. 120th St, Overland Park, KS 66213"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=12401+W+120th+St%2C+Overland+Park%2C+KS+66213"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.stonebriarwoods.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-c894-731b-9794-a25a986bc4da.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and kitchen area with white cabinets and stainless steel appliances."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": [
      "ec_22c0583aad402f19a2bdc462",
      "ec_4fca1ec783aff4f34ea8b9ea",
      "ec_82d937a16070dde7a6980aa2",
      "ec_40648a3bb2fcbca112b45a97",
      "ec_2a885537d8e76a1c459fc066",
      "ec_a9e71df0e592415caf3ed9ab",
      "ec_989913cfbe67fc47a45df182",
      "ec_552e896bde1b50018a047714",
      "ec_956caa7896f42e7db40c0904",
      "ec_cd814429aab75ff066adcdf8"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": 9,
    "hiddenIds": null,
    "orderedIds": [
      "ec_064ea900b2d37a0392812e57",
      "ec_347e7dfbb02c62caecf1453b",
      "ec_2b1f997f0a4020a3d1f3d65c",
      "ec_5d4e39001994104d20f52d59",
      "ec_9ffd47c714275c7e18a9c1fb",
      "ec_763428946c1bd8c6879e6ce1",
      "ec_a7bda3c06570e2213674f33a",
      "ec_6c7e032339a3c0ebd8d81d55",
      "ec_8117e1479ae6c3be3ac585b1",
      "ec_983421da20082b9efa7bf6d5",
      "ec_8dd03c19e4f94cad6408dfd1",
      "ec_bc2689de759cfb15a80dcebd",
      "ec_8da28763eca6c8295f768d8a",
      "ec_02834375bcab77a68441dc96",
      "ec_256f863f98c7e79f93a2750b",
      "ec_09c1bee4e071ab0f23182d49",
      "ec_7dabc85d473c6617facce77a",
      "ec_cc68a7286a8cf50ca139d67a",
      "ec_2814af277b7bb5d386deec43",
      "ec_5b91ef32e2b821aa0ab927bf",
      "ec_d850c863f141ace5785b2c3c"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_6f9bbced46e1ff7a0184a0e3",
      "ec_af40788048df40089c6ae866",
      "ec_555683291353d3fe6a301840",
      "ec_d0a90b3e931670579ac46ec4",
      "ec_1e518a6650f6f874aa89fc05",
      "ec_799e6adad27aff3054ee372b",
      "ec_fdef4a4a7a138c59eb2e0292",
      "ec_7633b17d6016aadd9f4217ae",
      "ec_872b942196125ab52947cf61",
      "ec_e28b36dcc172a3a9da72b240",
      "ec_76c3d3c9f3954c987d589dec"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync-map",
      "position": 7
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  }
};
